// New (manual) ticket form: validation and request body. A manual ticket is
// for walk-in and phone reports; the chatbot makes the rest. It goes through
// the same duplicate check, routing and SLA as a bot ticket.
import { hasRooms } from './residentsForm';

const DESCRIPTION_MAX = 4000;

export function emptyTicket() {
  return {
    condo_id: '',
    common_area: false,
    unit_id: '',
    room_id: '',
    tenant_id: '',
    category: '',
    source: '',
    severity: '',
    location_type: '',
    emergency: false,
    description: '',
  };
}

// `unit` is the selected unit (a rental one may be left without a room: the
// whole unit is accepted).
export function validateTicket(form) {
  const errors = {};
  if (!form.condo_id) errors.condo_id = 'CONDO';
  if (!form.common_area && !form.unit_id) errors.unit_id = 'UNIT';
  if (!form.category) errors.category = 'CATEGORY';
  if (!form.source) errors.source = 'SOURCE';
  const description = form.description.trim();
  if (!description || description.length > DESCRIPTION_MAX) {
    errors.description = 'DESCRIPTION';
  }
  return errors;
}

export function ticketPayload(form, unit) {
  const body = {
    condo_id: form.condo_id,
    common_area: form.common_area,
    category: form.category,
    source: form.source,
    emergency: form.emergency,
    description: form.description.trim(),
  };
  if (!form.common_area) {
    body.unit_id = form.unit_id;
    // A room only goes with a rental unit.
    if (form.room_id && unit && hasRooms(unit.kind))
      body.room_id = form.room_id;
  }
  if (form.tenant_id) body.tenant_id = form.tenant_id;
  if (form.severity) body.severity = form.severity;
  // Picking "common area" as the location also marks the ticket as one.
  if (form.location_type) body.location_type = form.location_type;
  return body;
}
